import { observer } from 'mobx-react';
import React from 'react';
import ListComponent from './component/ListComponent';
const Dashboard = observer(() => {
	return (
		<>
			<div className="mainPageWrap">
				<ListComponent />
			</div>
		</>
	);
});

export default Dashboard;
